import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

import useToaster from 'hooks/useToaster';
import { TranslationKey } from 'utils/translate';
import { IAffiliateNotification, AffiliateNotificationType } from 'types/notifications';
import useNotifications from 'store/notifications';

export const useHandleNotification = (): ((params: IAffiliateNotification) => void) => {
  const notify = useToaster();
  const navigate = useNavigate();
  const [, notificationActions] = useNotifications();
  const handleNotification = useCallback(
    (notification: IAffiliateNotification): void => {
      notificationActions.addNotification(notification);
      switch (notification.actionId) {
        case AffiliateNotificationType.WITHDRAW_REQUEST_APPROVED: {
          notify({
            type: 'info',
            message: notification.content as TranslationKey,
            title: notification.subject as TranslationKey,
            onClick: (): void => {
              navigate(`/affiliates/${notification.data.affiliateId}/wallet-history`);
              notificationActions.updateNotificationById(notification.id);
            },
          });
          break;
        }
        case AffiliateNotificationType.COMMISSION_CALCULATED: {
          notify({
            type: 'info',
            message: notification.content as TranslationKey,
            title: notification.subject as TranslationKey,
            onClick: (): void => {
              navigate(`/affiliates/${notification.data.affiliateId}/wallet-history`);
              notificationActions.updateNotificationById(notification.id);
            },
          });
          break;
        }
        case AffiliateNotificationType.NEW_PLAYER_REGISTERED: {
          notify({
            type: 'info',
            message: notification.content as TranslationKey,
            title: notification.subject as TranslationKey,
            onClick: (): void => {
              navigate(`/players/${notification.data.playerId}/dashboard`);
              notificationActions.updateNotificationById(notification.id);
            },
          });
          break;
        }
        case AffiliateNotificationType.AFFILIATE_REGISTERED: {
          notify({
            type: 'info',
            message: notification.content as TranslationKey,
            title: notification.subject as TranslationKey,
            onClick: (): void => {
              navigate(`/dashboard`);
              notificationActions.updateNotificationById(notification.id);
            },
          });
          break;
        }
        default:
          break;
      }
    },
    [navigate, notify, notificationActions],
  );

  return handleNotification;
};
